export const eventProps = (state, city, fuelName) => ({
    state_name: state,
    city_name: city,
    fuel_type: fuelName,
  })
